import React from 'react';

import NodeProductFull from './Full';
import NodeProductTeaser from './Teaser';

const NodeProduct = (props) => {
  const { viewMode } = props;
  switch (viewMode) {
    case 'teaser':
      // eslint-disable-next-line react/jsx-props-no-spreading
      return <NodeProductTeaser {...props} />;

    default:
      // eslint-disable-next-line react/jsx-props-no-spreading
      return <NodeProductFull {...props} />;
  }
};

export default NodeProduct;
